import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createUnknownComponentVNode as _$cc, createTextVNode as _$ct, extend as _$ex, EMPTY_OBJ as _$em, createElementVNode as _$ce, noop as _$no } from 'intact-vue-next';
import { TransitionGroup } from 'intact-vue-next';
import { getRestProps } from '../utils';
import { makeTagsStyles } from './styles';
import { Tag } from './';
import { Tooltip } from '../tooltip';
import { Tags } from './tags';
import { Virtual } from '../virtual';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj, _$cn2;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    className = _this$get.className,
    nowrap = _this$get.nowrap,
    size = _this$get.size,
    border = _this$get.border,
    draggable = _this$get.draggable;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-tags"] = true, _classNameObj[k + "-nowrap"] = nowrap, _classNameObj[k + "-draggable"] = draggable, _classNameObj[makeTagsStyles(k)] = true, _classNameObj[className] = className, _classNameObj);
  var _this$nowrap = this.nowrap,
    containerRef = _this$nowrap.containerRef,
    children = _this$nowrap.children,
    hiddenChildren = _this$nowrap.hiddenChildren;
  var vNodes = children.value;

  /**
  * We should always render Tooltip in nowrap mode, otherwise it will be removed while we close one tag.
  * Because we will render all tags to calculate the width
  */
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this), {
    'ref': containerRef
  }), [!nowrap ? _$cc(TransitionGroup, {
    'name': 'k-fade',
    'children': vNodes
  }) : vNodes, nowrap ? _$cc(Tooltip, {
    'key': '$tooltip',
    'hoverable': true,
    'theme': 'light',
    'className': _$cn(k + "-tags-tooltip"),
    'children': _$cc(Tag, {
      'key': '$more',
      'className': _$cn((_$cn2 = {}, _$cn2[k + "-tags-more"] = true, _$cn2['c-hidden'] = !hiddenChildren.value.length, _$cn2)),
      'size': size,
      'border': border,
      'children': [_$ct('\n            +'), hiddenChildren.value.length]
    }, '$more'),
    '$blocks': function ($blocks) {
      var _$blocks = {},
        __$blocks = _$ex({}, $blocks);
      return (_$blocks['content'] = function ($super) {
        var _extends2;
        return _$ce(2, 'div', hiddenChildren.value, 0, _$cn(_extends({}, classNameObj, (_extends2 = {}, _extends2[k + "-nowrap"] = false, _extends2))));
      }, __$blocks['content'] = function ($super, data) {
        var block = $blocks['content'];
        var callBlock = function callBlock() {
          return _$blocks['content'].call($this, $super, data);
        };
        return block ? block.call($this, callBlock, data) : callBlock();
      }), __$blocks;
    }.call($this, _$em)
  }, '$tooltip') : undefined, (_$blocks['append'] = function ($super) {
    return null;
  }, __$blocks['append'] = function ($super, data) {
    var block = $blocks['append'];
    var callBlock = function callBlock() {
      return _$blocks['append'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['append'](_$no))]);
}
;